/**
 * Coure.Hub.Service.Creation
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AllNetworkResponseDto } from '../model/allNetworkResponseDto';
import { CreateVasServiceNetwokRequestDto } from '../model/createVasServiceNetwokRequestDto';
import { NetworkResponseDto } from '../model/networkResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class VasServiceNetworkService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceNetworkCreateVasServiceNetworkPost(body?: CreateVasServiceNetwokRequestDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiVasServiceNetworkCreateVasServiceNetworkPost(body?: CreateVasServiceNetwokRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiVasServiceNetworkCreateVasServiceNetworkPost(body?: CreateVasServiceNetwokRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiVasServiceNetworkCreateVasServiceNetworkPost(body?: CreateVasServiceNetwokRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/VasServiceNetwork/CreateVasServiceNetwork`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param networkId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceNetworkDeleteServeiceNetworkNetworkIdDelete(networkId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiVasServiceNetworkDeleteServeiceNetworkNetworkIdDelete(networkId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiVasServiceNetworkDeleteServeiceNetworkNetworkIdDelete(networkId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiVasServiceNetworkDeleteServeiceNetworkNetworkIdDelete(networkId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (networkId === null || networkId === undefined) {
            throw new Error('Required parameter networkId was null or undefined when calling apiVasServiceNetworkDeleteServeiceNetworkNetworkIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/VasServiceNetwork/DeleteServeiceNetwork/${encodeURIComponent(String(networkId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceNetworkGetAllVasServiceNetworkGet(observe?: 'body', reportProgress?: boolean): Observable<Array<AllNetworkResponseDto>>;
    public apiVasServiceNetworkGetAllVasServiceNetworkGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AllNetworkResponseDto>>>;
    public apiVasServiceNetworkGetAllVasServiceNetworkGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AllNetworkResponseDto>>>;
    public apiVasServiceNetworkGetAllVasServiceNetworkGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<AllNetworkResponseDto>>('get',`${this.basePath}/api/VasServiceNetwork/GetAllVasServiceNetwork`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param networkId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceNetworkGetVasServiceNetworkByNetworkIdNetworkIdGet(networkId: string, observe?: 'body', reportProgress?: boolean): Observable<NetworkResponseDto>;
    public apiVasServiceNetworkGetVasServiceNetworkByNetworkIdNetworkIdGet(networkId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NetworkResponseDto>>;
    public apiVasServiceNetworkGetVasServiceNetworkByNetworkIdNetworkIdGet(networkId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NetworkResponseDto>>;
    public apiVasServiceNetworkGetVasServiceNetworkByNetworkIdNetworkIdGet(networkId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (networkId === null || networkId === undefined) {
            throw new Error('Required parameter networkId was null or undefined when calling apiVasServiceNetworkGetVasServiceNetworkByNetworkIdNetworkIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<NetworkResponseDto>('get',`${this.basePath}/api/VasServiceNetwork/GetVasServiceNetworkByNetworkId/${encodeURIComponent(String(networkId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceNetworkGetVasServiceNetworkByServiceIdServiceIdGet(serviceId: string, observe?: 'body', reportProgress?: boolean): Observable<NetworkResponseDto>;
    public apiVasServiceNetworkGetVasServiceNetworkByServiceIdServiceIdGet(serviceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NetworkResponseDto>>;
    public apiVasServiceNetworkGetVasServiceNetworkByServiceIdServiceIdGet(serviceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NetworkResponseDto>>;
    public apiVasServiceNetworkGetVasServiceNetworkByServiceIdServiceIdGet(serviceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceId === null || serviceId === undefined) {
            throw new Error('Required parameter serviceId was null or undefined when calling apiVasServiceNetworkGetVasServiceNetworkByServiceIdServiceIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<NetworkResponseDto>('get',`${this.basePath}/api/VasServiceNetwork/GetVasServiceNetworkByServiceId/${encodeURIComponent(String(serviceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param shortCode 
     * @param keyword 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceNetworkGetVasServiceNetworkByShortCodeAndKeywordShortCodeKeywordGet(shortCode: string, keyword: string, observe?: 'body', reportProgress?: boolean): Observable<NetworkResponseDto>;
    public apiVasServiceNetworkGetVasServiceNetworkByShortCodeAndKeywordShortCodeKeywordGet(shortCode: string, keyword: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NetworkResponseDto>>;
    public apiVasServiceNetworkGetVasServiceNetworkByShortCodeAndKeywordShortCodeKeywordGet(shortCode: string, keyword: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NetworkResponseDto>>;
    public apiVasServiceNetworkGetVasServiceNetworkByShortCodeAndKeywordShortCodeKeywordGet(shortCode: string, keyword: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (shortCode === null || shortCode === undefined) {
            throw new Error('Required parameter shortCode was null or undefined when calling apiVasServiceNetworkGetVasServiceNetworkByShortCodeAndKeywordShortCodeKeywordGet.');
        }

        if (keyword === null || keyword === undefined) {
            throw new Error('Required parameter keyword was null or undefined when calling apiVasServiceNetworkGetVasServiceNetworkByShortCodeAndKeywordShortCodeKeywordGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<NetworkResponseDto>('get',`${this.basePath}/api/VasServiceNetwork/GetVasServiceNetworkByShortCodeAndKeyword/${encodeURIComponent(String(shortCode))}/${encodeURIComponent(String(keyword))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param shortCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceNetworkGetVasServiceNetworkByShortCodeShortCodeGet(shortCode: string, observe?: 'body', reportProgress?: boolean): Observable<NetworkResponseDto>;
    public apiVasServiceNetworkGetVasServiceNetworkByShortCodeShortCodeGet(shortCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NetworkResponseDto>>;
    public apiVasServiceNetworkGetVasServiceNetworkByShortCodeShortCodeGet(shortCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NetworkResponseDto>>;
    public apiVasServiceNetworkGetVasServiceNetworkByShortCodeShortCodeGet(shortCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (shortCode === null || shortCode === undefined) {
            throw new Error('Required parameter shortCode was null or undefined when calling apiVasServiceNetworkGetVasServiceNetworkByShortCodeShortCodeGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<NetworkResponseDto>('get',`${this.basePath}/api/VasServiceNetwork/GetVasServiceNetworkByShortCode/${encodeURIComponent(String(shortCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param vasServiceId 
     * @param networkId 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceNetworkGetVasServiceNetworkByVasServiceIdAndNetworkIdVasServiceIdNetworkIdGet(vasServiceId: string, networkId: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<NetworkResponseDto>;
    public apiVasServiceNetworkGetVasServiceNetworkByVasServiceIdAndNetworkIdVasServiceIdNetworkIdGet(vasServiceId: string, networkId: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NetworkResponseDto>>;
    public apiVasServiceNetworkGetVasServiceNetworkByVasServiceIdAndNetworkIdVasServiceIdNetworkIdGet(vasServiceId: string, networkId: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NetworkResponseDto>>;
    public apiVasServiceNetworkGetVasServiceNetworkByVasServiceIdAndNetworkIdVasServiceIdNetworkIdGet(vasServiceId: string, networkId: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (vasServiceId === null || vasServiceId === undefined) {
            throw new Error('Required parameter vasServiceId was null or undefined when calling apiVasServiceNetworkGetVasServiceNetworkByVasServiceIdAndNetworkIdVasServiceIdNetworkIdGet.');
        }

        if (networkId === null || networkId === undefined) {
            throw new Error('Required parameter networkId was null or undefined when calling apiVasServiceNetworkGetVasServiceNetworkByVasServiceIdAndNetworkIdVasServiceIdNetworkIdGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<NetworkResponseDto>('get',`${this.basePath}/api/VasServiceNetwork/GetVasServiceNetworkByVasServiceIdAndNetworkId/${encodeURIComponent(String(vasServiceId))}/${encodeURIComponent(String(networkId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
